import React from 'react';
import { Button, Divider, Stack, Typography, Box } from '@mui/material';
import { ExitToApp as LogoutIcon, OpenInNew } from '@mui/icons-material';

import { documentationUrl } from '../../util/constants';

type Props = {
  logout: () => void;
};

const menuButtonSx = {
  justifyContent: 'flex-start',
  fontSize: '14px',
  textTransform: 'none',
  width: '100%',
  color: 'text.primary',
} as const;

const AccountTooltip = ({ logout }: Props) => {
  return (
    <Stack spacing={1} sx={{ p: 2, minWidth: '250px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="large" color="text.primary" fontWeight="semibold">
          Welcome
        </Typography>
      </Box>
      <Divider />
      <Button
        variant="text"
        component="a"
        href={documentationUrl}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<OpenInNew />}
        disableRipple
        data-testid="account-menu-documentation"
        sx={menuButtonSx}
      >
        Documentation
      </Button>
      <Button
        variant="text"
        onClick={logout}
        startIcon={<LogoutIcon />}
        disableRipple
        sx={menuButtonSx}
      >
        Logout
      </Button>
    </Stack>
  );
};

export default AccountTooltip;
